// src/hooks/useDebounce.js
import { useState, useEffect } from 'react';

/**
 * Hook customizado que atrasa a atualização de um valor.
 * É útil para evitar chamadas de API excessivas em campos de busca.
 * @param {any} value - O valor a ser "debounced".
 * @param {number} delay - O tempo de atraso em milissegundos.
 * @returns {any} - O valor após o atraso.
 */
export const useDebounce = (value, delay) => {
    // Estado para armazenar o valor "debounced"
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        // Configura um temporizador para atualizar o valor debounced após o delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // Função de limpeza: cancela o temporizador se o valor ou o delay mudarem
        // antes que o temporizador termine. Isso evita que o valor antigo seja setado.
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]); // Apenas re-executa o efeito se o valor ou o delay mudarem

    return debouncedValue;
};